import script from "./AddQuestionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQuestionView.vue?vue&type=script&setup=true&lang=ts"

import "./AddQuestionView.vue?vue&type=style&index=0&id=0faedf62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0faedf62"]])

export default __exports__